module.exports = __webpack_public_path__ + "static/media/Inter-Bold.895ddea9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Bold.woff
// module id = 679
// module chunks = 21